import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const SecurityPasswordPolicies = ({handleChange}) => {
    const {
        settingData, 
    } = useMenu();
    
    

    return (
        <> 
            {/* {console.log('options', options)} */}
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable password & login security policies", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Apply the password policies that you set from the settings below.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable password policy.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Password policy", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "Enable/disable password policy.", "ultimate-security" )}</p>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.password_policies.activate_password_policies"
                                    checked={settingData?.security?.['password_policies']?.activate_password_policies} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={`${settingData?.security?.['password_policies']?.activate_password_policies !== "1" ? 'deactive-section' : ''}`}>    

                <div className="setting-unit pb-lg mb-lg border-bottom">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Password policies", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Define your password policies like minimum password strength, uppercase, lowercase, numeric, etc conditions.", "ultimate-security")}</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title-group">
                                <h6 className="pl-heading-1 fw-600 text-text">{__("Password must be minimum", "ultimate-security")}</h6>
                            </div>
                            <div className="title-group d-flex align-items-center mt-2">
                                <Hint position="bottom" content={__("Minimum password requirement", "ultimate-security")}/>                                
                                <span className="w-130">
                                    <input 
                                        className="form-control"
                                        type="text" 
                                        value={settingData?.security?.['password_policies']?.min_length}
                                        onChange={(e)=> handleChange('security.password_policies.min_length', e.target.value)}
                                    />
                                </span> 
                                <span>{__("Characters.", "ultimate-security")}</span>
                            </div>

                            <div className="row justify-content-between mt-2">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Uppercase/lowercase password policy", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Password must contain at least one uppercase and one lowercase character.", "ultimate-security")}</h6>
                                    </div>
                                </div>                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.password_policies.ui_rules_mix_case"
                                        checked={settingData?.security?.['password_policies']?.ui_rules_mix_case} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>

                            <div className="row justify-content-between mt-2">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Numeric password policy", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Password must contain at least one numeric character ( 0-9 ).", "ultimate-security")}</h6>
                                    </div>
                                </div>                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.password_policies.ui_rules_numeric"
                                        checked={settingData?.security?.['password_policies']?.ui_rules_numeric} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>

                            <div className="row justify-content-between mt-2">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Special character password policy", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Password must contain at least one special character (eg: [!@#$%^&*()_?£\"+-=;:<>]).", "ultimate-security")}</h6>
                                    </div>
                                </div>                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.password_policies.ui_rules_special_chars"
                                        checked={settingData?.security?.['password_policies']?.ui_rules_special_chars} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>
                            <div className="row justify-content-between mt-2">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Banned special character password policy", "ultimate-security")}/>
                                        <h6 className="pl-heading-1 fw-600 text-text">{__("Do not show these special characters in passwords:", "ultimate-security")}</h6>
                                    </div>
                                </div>                                
                                <div className="col-auto">
                                    <Switch 
                                        name="security.password_policies.ui_rules_exclude_special_chars"
                                        checked={settingData?.security?.['password_policies']?.ui_rules_exclude_special_chars} // Pass "1"/"0" from API 
                                        onChange={handleChange} 
                                    />
                                </div>
                            </div>
                            <div className="row justify-content-between mt-2">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("No Hint", "ultimate-security")}/>
                                        <input 
                                            className="form-control"
                                            type="text"
                                            value={settingData?.security?.['password_policies']?.excluded_special_chars}
                                            onChange={(e) => handleChange('security.password_policies.excluded_special_chars', e.target.value)}
                                        />
                                    </div>
                                    <div className="content-below-with-hint mt-2">                                    
                                        <p className="pl-body text-text">{__( "To enter multiple special characters simply type them in one next to the other.", "ultimate-security" )}</p>
                                        <InfoBox className="small-infobox mt-2" title={__("Note", "ultimate-security")} content={__("These password policies will only apply to new users.", "ultimate-security")} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="setting-unit pb-lg mb-lg border-bottom">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Password expiration policy", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Passwords should automatically expire in", "ultimate-security")}</p>                            
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Set expiration duration", "ultimate-security")}/>
                                        <div className="d-flex align-items-center">
                                            <span className="w-130">
                                                <input 
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    value={settingData?.security?.['password_policies']?.password_expiry_value}
                                                    onChange={(e) => handleChange('security.password_policies.password_expiry_value', e.target.value)}
                                                />
                                            </span>
                                            <div className={`units ${settingData?.security?.['password_policies']?.password_expiry_value < 1 ?'deactive-section':''}`}>
                                                <span 
                                                    className={`unit ${settingData?.security?.['password_policies']?.password_expiry_unit == 'month'?'active-unit':''}`}
                                                    onClick={()=>handleChange('security.password_policies.password_expiry_unit', 'month')}
                                                >
                                                    {__("Month", "ultimate-security")}
                                                </span>
                                                <span
                                                    className={`unit ${settingData?.security?.['password_policies']?.password_expiry_unit == 'year'?'active-unit':''}`}
                                                    onClick={()=>handleChange('security.password_policies.password_expiry_unit', 'year')}
                                                >
                                                    {__("Year", "ultimate-security")}
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="content-below-with-hint mt-2">                                    
                                        <p className="pl-body text-text">{__( "Set to O to disabe automatic expiration.", "ultimate-security" )}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="setting-unit pb-lg mb-lg border-bottom">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Disallow old passwords on reset", "ultimate-security")}</h5>
                                <p className="pl-body text-text">{__("Discourage users to reuse their old passwords for a certain number of times.", "ultimate-security")}</p>                            
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center ">
                                        <Hint content={__("Set expiration duration", "ultimate-security")}/>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="w-130">
                                                <input 
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    value={settingData?.security?.['password_policies']?.password_history}
                                                    onChange={(e) => handleChange('security.password_policies.password_history', e.target.value)}
                                                />
                                            </span>
                                            <span>{__("Password", "ultimate-security")}</span>
                                        </div>
                                        
                                    </div>
                                    <div className="content-below-with-hint mt-2">                                    
                                        <p className="pl-body text-text">{__( "You can configure the plugin to remember up to 100 previously used passwords that users cannot use. It will remember the last 1 password by default (minimum value: 1).", "ultimate-security" )}</p>
                                        <InfoBox className="small-infobox mt-2" title={__("Note", "ultimate-security")} content={__("These password policies will only apply to new users.", "ultimate-security")} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Reset password on first login", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Password policy for first login", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Reset password for first login", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "Enable this setting to force new users to reset their password the first time they login.", "ultimate-security" )}</p>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.password_policies.change_initial_password"
                                    checked={settingData?.security?.['password_policies']?.change_initial_password} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Disable sending of password reset links", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Disable password reset link", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Do not send password reset links", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "By default users who forget their password can request a password reset link that is sent to their email address Enable this setting to stop WordPress sending these links, so users have to contact the website administrator if they forgot their password and need to reset it.", "ultimate-security" )}</p>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.password_policies.disable_self_reset"
                                    checked={settingData?.security?.['password_policies']?.disable_self_reset} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Set content of the Password Reset Link", "ultimate-security")}</h5>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center mb-3">
                                    <Hint content={__("Set password reset link text", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="text"
                                        value={settingData?.security?.['password_policies']?.content_self_reset}
                                        onChange={(e) => handleChange('security.password_policies.content_self_reset', e.target.value)}
                                        style={{marginBottom: '5px'}}
                                        placeholder={__('Contact site administrator to reset your account password.', "ultimate-security" )}
                                    />
                                </div>
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set password reset link URL", "ultimate-security")}/>
                                    <input 
                                        className="form-control"
                                        type="url"
                                        value={settingData?.security?.['password_policies']?.url_self_reset}
                                        onChange={(e) => handleChange('security.password_policies.url_self_reset', e.target.value)}
                                        placeholder='#'
                                    />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <p className="pl-body text-text">{__( "Replace the following text with the password reset link text.", "ultimate-security" )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityPasswordPolicies, 'security.password_policies');